import {
  SET_GROUP,
  SET_GROUP_STORE,
  SET_GROUP_PERMISSIONS,
  TOGGLE_SWITCH_STORE_POPUP,
  RESET_GROUP_STATE,
  SET_TEAM_MEMBER,
} from "../types";

const initialState = {
  group: {},
  store: {},
  teamMember: {},
  permissions: {},
  isSwitchStoreOpen: false,
};

const group = (state = initialState, action) => {
  switch (action.type) {
    case SET_GROUP:
      return {
        ...state,
        group: action.payload,
      };
    case SET_GROUP_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };
    case SET_GROUP_STORE:
      return {
        ...state,
        store: action.payload,
      };
    case SET_TEAM_MEMBER:
      return {
        ...state,
        teamMember: action.payload,
      };
    case TOGGLE_SWITCH_STORE_POPUP:
      return {
        ...state,
        isSwitchStoreOpen: action.payload,
      };
    case RESET_GROUP_STATE:
      return initialState;
    default:
      return state;
  }
};

export default group;
